// src/utils/campaignConstants.js
export const promotionTypes = [
  { value: "flat_percent", label: "Flat Percent Discount" },
  { value: "flat_dollar", label: "Flat Dollar Discount" },
  { value: "buy_x_get_rs_y_off", label: "Buy Above X, Get $Y Off" },
  {
    value: "buy_x_get_y_percent_upto_z",
    label: "Buy Above X, Get Y% Off (Upto $Z)",
  },
  {
    value: "flat_percent_if_greater_than_x",
    label: "Y Percent if Quanitity > X",
  },
];

export const promotionTypeFields = {
  flat_percent: ["xValue"],
  flat_dollar: ["xValue"],
  buy_x_get_rs_y_off: ["xValue", "yValue"],
  buy_x_get_y_percent_upto_z: ["xValue", "yValue", "zValue"],
  flat_percent_if_greater_than_x: ["xValue , xValue"],
};

export const serviceTypes = [
  { value: "WASH_N_FOLD", label: "Wash & Fold" },
  { value: "DRYCLEANING", label: "Dry Cleaning" },
  { value: "TAILORING", label: "Tailoring" },
];

export const customerTags = [
  { value: "VIP", label: "VIP" },
  { value: "NEW", label: "New" },
  { value: "AT_RISK", label: "At Risk" },
];

export const regions = [
  { value: "manhattan", label: "Manhattan" },
  { value: "boston", label: "Boston" },
  { value: "new_york", label: "New York" },
];

export const campaignBreadcrumb = [
  { to: "/app/promotions&marketing", title: "Campaign " },
  { title: "Create Campaign" },
];

export const campaignVisibility = [
  { label: "Public", value: "Public" },
  { label: "Private", value: "Private" },
];

export const categoryOptionsInventory = [
  { label: "Consumables", value: "Consumables" },
  { label: "Retail Add-ons", value: "Retail Add-ons" },
  { label: "Packaging & Supplies", value: "Packaging & Supplies" },
  { label: "Operational Tools", value: "Operational Tools" },
];

export const categoryValueToLabel = (value) => {
  switch (value) {
    case "Consumables":
      return "Consumables";
    case "RETAIL_ADD_ONS":
      return "Retail Add-ons";
    case "PACKAGING_SUPPLIES":
      return "Packaging & Supplies";
    case "OPERATIONAL_TOOLS":
      return "Operational Tools";
    default:
      return value;
  }
};

export const customerValueToLabel = (value) => {
  switch (value) {
    case "AT_RISK":
      return "At Risk";
    case "NEW":
      return "New";
    case "VIP":
      return "vip";
    default:
      return value;
  }
};
